module.exports = __webpack_public_path__ + "img/huancayo.63d7124.png";